import React, { createContext, useContext } from 'react'
import targetingPermissions from '../permissions/targeting.json'
import changeRequestsPermissions from '../permissions/changeRequests.json'

const permissions = { ...targetingPermissions, ...changeRequestsPermissions }

const PermissionsContext = createContext(permissions)

export function PermissionsProvider({ children }) {
    return (
        <PermissionsContext.Provider value={permissions}>
            {children}
        </PermissionsContext.Provider>
    )
}

export function usePermissions() {
    return useContext(PermissionsContext)
}

export default PermissionsContext
